import { useQueryParam } from "@/hooks/useQueryParam";
import { DateTime } from "luxon";

/**
 * Custom hook to retrieve and validate the `datetime` query parameter.
 * @returns A Luxon DateTime object if valid, or null if invalid or not provided.
 */
export const useDateTimeFromUrl = (): DateTime | null => {
  // Use the existing hook to retrieve the query parameter
  const datetimeParam = useQueryParam("datetime");

  if (!datetimeParam) {
    return null;
  }

  // Parse and validate the datetime string using Luxon
  const parsedDateTime = DateTime.fromISO(datetimeParam);
  return parsedDateTime.isValid ? parsedDateTime : null;
};
